export const QipWithGroupsKeys = {
  baseKey: 'qipwithGroups' as const,
  all: ['qipWithGroups'] as const,
  questions: () => [...QipWithGroupsKeys.all, 'questions'] as const,
  question: (id: string) => [...QipWithGroupsKeys.questions(), id] as const,
};
